import { makeStyles } from '@coachhubio/ui-components';
import styled from 'styled-components';

import { Iframe } from '../components/Iframe';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    minHeight: '100vh',
    backgroundColor: theme.brandPalette.white,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    flexGrow: 1,
    padding: 20,
  },
  wrapperScaled: {
    width: '100%',
    maxWidth: 1332,
    margin: '0 auto',
  },
  iframePadding: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    [`@media screen and (min-width: 1060px)`]: {
      paddingLeft: '1.25rem',
      paddingRight: '1.25rem',
    },
    [`@media screen and (min-width: 1490px)`]: {
      paddingLeft: '3.75rem',
      paddingRight: '3.75rem',
    },
  },
  container: {
    marginBottom: 0,
    height: '100%',
    width: '100%',
  },
  containerScaled: {
    marginBottom: 0,
    height: '100%',
  },
  logo: {
    height: '50px',
    padding: '10px',
  },
  title: {
    justifyContent: 'space-between',
    height: '65px',
  },
}));

export const SIframe = styled(Iframe)`
  height: 100%;
  width: 100%;
`;
